const WA_LINK = "https://wa.me/393296281756?text=Ciao%20Danielealoisi%2C%20vorrei%20un%20preventivo%2Fsopralluogo%20per%20infissi%20o%20lavorazioni%20in%20ferro.%20Zona%3A%20_____%20.%20Posso%20inviare%20alcune%20foto.";
const MAPS_LINK = "https://www.google.com/maps/place//data=!4m2!3m1!1s0x132f783c46eacbd3:0xf754ca92e2a42d9d?sa=X&ved=1t:8290&ictx=111";
const FB_LINK = "https://www.facebook.com/CIAMdiAloisiDaniele?mibextid=wwXIfr&rdid=JeRZSIFrNAZYQgVp&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F15ubAtGDKg%2F%3Fmibextid%3DwwXIfr";

const Footer = () => {
  return (
    <footer className="bg-background border-t border-border py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand */}
        <div>
          <h3 className="font-heading text-xl font-bold text-foreground mb-4">Danielealoisi</h3>
          <p className="text-muted-foreground text-sm font-body leading-relaxed">
            Infissi, serramenti e lavorazioni in ferro su misura tra Roma e Guidonia. Puntualità, pulizia e assistenza fino alla fine.
          </p>
        </div>

        {/* Contatti */}
        <div>
          <h4 className="font-heading text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">
            Contatti
          </h4>
          <div className="space-y-2 text-sm font-body">
            <p className="text-foreground/70">Via Col di Mezzo, 8F – 00012 La Botte (RM)</p>
            <p><a href="tel:+390774326428" className="text-foreground/70 hover:text-foreground transition-colors duration-300">Fisso: 0774 326428</a></p>
            <p><a href="tel:+393296281756" className="text-foreground/70 hover:text-foreground transition-colors duration-300">Cell: 329 6281756</a></p>
            <p><a href={WA_LINK} target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:text-[#20bd5a] transition-colors duration-300">WhatsApp</a></p>
            <p><a href="mailto:Daniele@aloisi.it" className="text-foreground/70 hover:text-foreground transition-colors duration-300">Daniele@aloisi.it</a></p>
            <a
              href={MAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-2 text-xs text-accent hover:text-accent/80 transition-colors duration-300 underline"
            >
              Apri su Google Maps
            </a>
          </div>
        </div>

        {/* Orari */}
        <div>
          <h4 className="font-heading text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">
            Orari
          </h4>
          <div className="space-y-1 text-sm font-body text-foreground/70">
            <p>Lun 08–13 / 15–18</p>
            <p>Mar 08–13 / 15–18</p>
            <p>Mer 08–18</p>
            <p>Gio 08–13 / 15–18</p>
            <p>Ven 08–13 / 15–18</p>
            <p>Sab 08–13</p>
            <p>Dom Chiuso</p>
          </div>
        </div>

        {/* Social */}
        <div>
          <h4 className="font-heading text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">
            Social
          </h4>
          <a
            href={FB_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-body text-foreground/50 hover:text-foreground transition-colors duration-300"
          >
            Facebook
          </a>
          <p className="mt-6 text-xs text-muted-foreground/50 font-body leading-relaxed">
            Agevolazioni e percentuali dipendono dalla normativa vigente e dai requisiti dell'immobile/cliente.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
        <p className="text-xs text-muted-foreground font-body">
          © 2026 Danielealoisi — Via Col di Mezzo, 8F – 00012 La Botte (RM)
        </p>
        <a href="#" className="text-xs text-muted-foreground font-body hover:text-foreground transition-colors duration-300">
          Privacy Policy
        </a>
      </div>
    </footer>
  );
};

export default Footer;